import React from 'react';
import "../styleFiles/Skills.css";

const Skills = () => {
    return (
    <div>
        <section>
            <h1 className='component-title'> My Earned Technologies via My Journey </h1>
            {/* General */}
            <section className='Container'>
                <h3> <i className="fa-solid fa-laptop-code"></i> General </h3>
                <hr/>
                <div className='d-flex justify-content-evenly flex-wrap'>
                    <SkillItem src='/assets/python.png' name='Python' />
                    <SkillItem src='/assets/C++.png' name='C++' />
                    <SkillItem src='/assets/CSharp.png' name='C#' />
                    <SkillItem src='/assets/Java.png' name='Java' />
                </div>
            </section>

            {/* Frontend */}
            <section className='Container'>
                <h3> <i className="fa-solid fa-code"></i> Frontend </h3>
                <hr/>
                <div className='d-flex justify-content-evenly flex-wrap'>
                    <SkillItem src='/assets/Html.png' name='HTML' />
                    <SkillItem src='/assets/CSS.png' name='CSS' />
                    <SkillItem src='/assets/SCSS.png' name='SCSS' />
                    <SkillItem src='/assets/JS.png' name='JavaScript' />
                    <SkillItem src='/assets/TS.png' name='TypeScript' />
                    <SkillItem src='/assets/React.png' name='React' />
                    <SkillItem src='/assets/Bootstrap.png' name='Bootstrap' />
                    <SkillItem src='/assets/Pug.png' name='Pug.js' />
                    <SkillItem src='/assets/Axios.png' name='Axios' />
                </div>
            </section>

            {/* Backend */}
            <section className='Container'>
                <h3> <i class="fa-solid fa-bug"></i> Backend </h3>
                <hr/>
                <div className='d-flex justify-content-evenly flex-wrap'>
                    <SkillItem src='/assets/Flask.png' name='Flask' />
                    <SkillItem src='/assets/Django.png' name='Django' />
                    <SkillItem src='/assets/FastAPI.png' name='FastAPI' />
                    <SkillItem src='/assets/JWT.png' name='JWT' />
                    <SkillItem src='/assets/Rest.png' name='REST API' />
                </div>
            </section>

            {/* AI & ML */}
            <section className='Container'>
                <h3> <i className="fa-solid fa-brain"></i> AI / Machine Learning </h3>
                <hr/>
                <div className='d-flex justify-content-evenly flex-wrap'>
                    <SkillItem src='/assets/TensorFlow.png' name='TensorFlow' />
                    <SkillItem src='/assets/Keras.png' name='Keras' />
                    <SkillItem src='/assets/sklearn.png' name='Scikit-learn' />
                    <SkillItem src='/assets/Pandas.png' name='Pandas' />
                    <SkillItem src='/assets/Numpy.png' name='Numpy' />
                </div>
            </section>

            {/* Databases */}
            <section className='Container'>
                <h3> <i className="fa-solid fa-database"></i> Databases </h3>
                <hr/>
                <div className='d-flex justify-content-evenly flex-wrap'>
                    <SkillItem src='/assets/PostgreSQL.png' name='PostgreSQL' />
                    <SkillItem src='/assets/MySQL.png' name='MySQL' />
                    <SkillItem src='/assets/SQL.png' name='SQL' />
                    <SkillItem src='/assets/SQLite.jpeg' name='SQLite' />
                </div>
            </section>

            {/* Tools */}
            <section className='Container'>
                <h3> <i className="fa-solid fa-toolbox"></i> Tools & DevOps </h3>
                <hr/>
                <div className='d-flex justify-content-evenly flex-wrap'>
                    <SkillItem src='/assets/Git.png' name='Git' />
                    <SkillItem src='/assets/GitHub.png' name='GitHub' />
                    <SkillItem src='/assets/Colab.png' name='Colab' />
                    <SkillItem src='/assets/Postman.png' name='Postman' />
                    <SkillItem src='/assets/Cmder.png' name='Cmder' />
                    <SkillItem src='/assets/MSOffice.png' name='MS Office' />
                </div>
            </section>

            {/* Servers */}
            <section className='Container'>
                <h3> <i className="fa-solid fa-toolbox"></i> Servers </h3>
                <hr/>
                <div className='d-flex justify-content-evenly flex-wrap'>
                    <SkillItem src='/assets/Vercel.png' name='Vercel' />
                    <SkillItem src='/assets/Hostinger.png' name='Hostinger' />
                    <SkillItem src='/assets/GithubPages.png' name='GithubPage' />
                    <SkillItem src='/assets/Neon.jpeg' name='Neon' />
                </div>
            </section>

        </section>
    </div>
    );
};

export const SkillItem = ({ src, name }) => (
    <div className="text-center m-3 skill-item">
        <div> <img src={src} alt={name} height="50" width="50" /> </div>
        <div><span>{name}</span></div>
    </div>
);

export default Skills;
